import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, GoogleAuthProvider, FacebookAuthProvider, TwitterAuthProvider, setPersistence } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBbDQJFa-kQsgd7LekQI4aLvbG5jeDF6jw",
  authDomain: "sdying-2026.firebaseapp.com",
  projectId: "sdying-2026",
  storageBucket: "sdying-2026.firebasestorage.app",
  messagingSenderId: "148047985755",
  appId: "1:148047985755:web:a44c0c00766d656f59537e",
  measurementId: "G-HEDE08RKKT",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const twitterProvider = new TwitterAuthProvider();

void setPersistence(firebaseAuth, browserLocalPersistence);

facebookProvider.setCustomParameters({
  display: "popup",
});

twitterProvider.setCustomParameters({
  lang: "zh-cn",
});

void isSupported().then((supported) => {
  if (supported) {
    getAnalytics(firebaseApp);
  }
});
